module.exports = __webpack_public_path__ + "static/img/Fitria Morouwsky-close.f2999cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/closeup/Fitria Morouwsky-close.jpg
// module id = BQ+K
// module chunks = 1